import NeedHelpStore from 'stores/NeedHelpStore'
import HotKeyStore from 'stores/HotKeyStore'
import PermissionsStore from 'stores/PermissionsStore'
import BadgesStore from 'stores/BadgesStore'
import CurrentAccountStore from 'stores/CurrentAccountStore'
import FiltersStore from 'stores/FiltersStore'
import PolicyStore from 'stores/PolicyStore'
import WithholdingStore from 'stores/WithholdingStore'
import ComunicationsStore from 'stores/ComunicationsStore'
import NotificationsStore from 'stores/NotificationsStore'
import QuotesStore from 'scenes/Quotes/QuotesStore'
import ClientsStore from 'scenes/Clients/ClientsStore'

class RootStore {
    constructor(authStore) {
        this.authStore = authStore
        this.hotKeyStore = new HotKeyStore()
        this.needHelpStore = new NeedHelpStore()
        this.badgesStore = new BadgesStore()
        this.currentAccountStore = new CurrentAccountStore()
        this.filtersStore = new FiltersStore()
        this.quotesStore = new QuotesStore()
        this.clientsStore = new ClientsStore()
        this.policyStore = new PolicyStore()
        this.withholdingStore = new WithholdingStore()
        this.comunicationsStore = new ComunicationsStore(false)
        this.notificationsStore = new NotificationsStore()

        const { authUser } = authStore
        this.permissionsStore = new PermissionsStore(authUser?.permissions)
    }

    /**
     * Clears listing caches and related session memory so data cannot leak across users.
     */
    clearSessionData() {
        const listingStores = [
            this.clientsStore,
            this.quotesStore,
            this.policyStore,
            this.withholdingStore,
            this.currentAccountStore,
            this.comunicationsStore,
            this.notificationsStore,
        ]

        listingStores.forEach((store) => {
            if (typeof store.clearListCache === 'function') {
                store.clearListCache()
            }
        })

        this.filtersStore.clear()
        this.badgesStore.clear()
        this.permissionsStore.update({})
    }
}

export default RootStore
